import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "../features/DataExtractionTool/Login/loginSlice";
import authenticationReducer from "../features/DataExtractionTool/Authentication/authenticationSlice";
import requestReducer from "../features/DataExtractionTool/Request/RequestSlice"
import individualSearchReducer from "../features/AHPRAValidationTool/Pages/IndividualSearchPage/individualSearchSlice"
import recordsHandlingReducer from "../features/AHPRAValidationTool/Pages/RecordsHandlingPage/recordsHandlingSlice"
import fileUploadReducer from '../features/Chiesi/state/FileUpload/fileUploadSlice';
import inProgressJobsReducer from "../features/Chiesi/pages/InProgressJobsPage/inProgressSlice";

import completedJobReducer from "../features/Chiesi/pages/CompletedJobsPage/completedSlice"
import matchReducer from "../features/Chiesi/state/Match/matchSlice";
import displayRecordsReducer from "../features/Chiesi/pages/DisplayRecordsPage/displayRecordsSlice";

export const store = configureStore({
  reducer: {
    login:loginReducer,
    request: requestReducer,
    authentication: authenticationReducer,
    individualSearch: individualSearchReducer,
    recordsHandling: recordsHandlingReducer,
    inProgressJobs: inProgressJobsReducer,
    completedJobs: completedJobReducer,
    fileUpload: fileUploadReducer,
    match: matchReducer,
    displayRecords: displayRecordsReducer,
  },
});
